import React, { createContext, useRef, useContext } from 'react';

const ScrollContext = createContext();

export const ScrollProvider = ({ children }) => {
  const sectionRefs = {
    top: useRef(null),
    testimonial: useRef(null),
    cartIcon: useRef(null),
    // Add more sections as needed
  };

  const scrollToSection = (section) => {
    sectionRefs[section]?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <ScrollContext.Provider value={{ sectionRefs, scrollToSection }}>
      <div ref={sectionRefs.top}>{children}</div>
    </ScrollContext.Provider>
  );
};

export const useScroll = () => useContext(ScrollContext);
